import { format } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";
import { fr, en } from 'date-fns/locale';
import { env } from "../../utils/env";

export function betterTime(sometime) {
	let dbTime = zonedTimeToUtc(sometime, window.DB_TIMEZONE);
	let formattedTime = format(dbTime, "dd/MM, HH:mm");
	return formattedTime;
}

export function betterTimeWithFormat(sometime, formatString) {
	let dbTime = zonedTimeToUtc(sometime, window.DB_TIMEZONE);

	let currentLang = env.locale.split('-')[0];
	//TODO: make it shared
	let langauges = {'fr':fr, 'en':en}

	let formattedTime = formatString ? format(dbTime, formatString, {locale: langauges[currentLang]}) : dbTime

	return formattedTime
}

export function currency(number) {
	return window.CURRENCY + number.toLocaleString(window.LOCALE);
}

export function getParameterByName(name, url) {
	url = window.location.href;
	name = name.replace(/[\[\]]/g, "\\$&");
	var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
		results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return "";
	return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export function millisToMinutesAndSeconds(millis) {
	var minutes = Math.floor(millis / 60000);
	var seconds = ((millis % 60000) / 1000).toFixed(0);
	return minutes + ":" + (seconds < 10 ? "0" : "") + seconds;
}

export function truncate(somestring, length) {
	return (
		somestring.substring(0, Math.min(length, somestring.length)) +
		(somestring.length >= length ? "..." : "")
	);
}

export function toTitleCase(str) {
	if (!str) return str;

	let parts = str.split(" ");
	let full = [];
	parts.forEach((part) => {
		if (part.length <= 2 && parts.length == 1)
			return full.push(part.toUpperCase());
		full.push(
			part.replace(/\w\S*|\/\*/g, function(txt) {
				return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
			})
		);
	});
	return full.join(" ");
}

export function focusAndOpenKeyboard(el, timeout) {
	if (!timeout) {
		timeout = 100;
	}
	if (el) {
		// Align temp input element approximately where the input element is
		// so the cursor doesn't jump around
		var __tempEl__ = document.createElement("input");
		__tempEl__.style.position = "absolute";
		__tempEl__.style.top = el.offsetTop + 7 + "px";
		__tempEl__.style.left = el.offsetLeft + "px";
		__tempEl__.style.height = 0;
		__tempEl__.style.opacity = 0;
		// Put this temp element as a child of the page <body> and focus on it
		document.body.appendChild(__tempEl__);
		__tempEl__.focus();

		// The keyboard is open. Now do a delayed focus on the target element
		setTimeout(function() {
			el.focus();
			el.click();
			// Remove the temp element
			document.body.removeChild(__tempEl__);
		}, timeout);
	}
}

export function validatePhoneNumber(phone) {
	const regex = new RegExp(MOBILE_REGEX);
	return regex.test(phone);
}

import Vue from "vue";
export const event = {
	bus: null,
	init() {
		if (!this.bus) {
			this.bus = new Vue();
		}
		return this;
	},
	emit(name, ...args) {
		this.bus.$emit(name, ...args);
		return this;
	},
	on() {
		arguments.length === 2
			? this.bus.$on(arguments[0], arguments[1])
			: Object.keys(arguments[0]).forEach((key) => {
					this.bus.$on(key, arguments[0][key]);
			});
		return this;
	},
};
